export const LOAD_CONSTS_SUCCESS = "LOAD_CONSTS_SUCCESS";
export const LOAD_GROUPS_LIST = "LOAD_GROUPS_LIST";
